// import List from '@/views/service-provider/List.vue'
// import Detail from '@/views/service-provider/Detail.vue'
// import Create from '@/views/service-provider/Create.vue'
const List = () =>
  import(
    /* webpackChunkName: "service-provider" */ '@/views/service-provider/List.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "service-provider" */ '@/views/service-provider/Detail.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "service-provider" */ '@/views/service-provider/Create.vue'
  )
const billOverview = () =>
  import(
    /* webpackChunkName: "service-provider" */ '@/views/channel/billOverview.vue'
  )
const billDetails = () =>
  import(
    /* webpackChunkName: "service-provider" */ '@/views/channel/billDetails.vue'
  )
const resourceBilling = () =>
  import(
    /* webpackChunkName: "service-provider" */ '@/views/channel/resourceBilling.vue'
  )
const channelCheckout = () =>
  import(
    /* webpackChunkName: "service-provider" */ '@/views/channel/channelCheckout.vue'
  )
export default function (router) {
  router.push({
    path: '/partner/service-provider',
    component: List,
    redirect: '/partner/service-provider/list',
  })
  // 我的下级渠道商列表
  router.push({
    path: '/partner/service-provider/list',
    name: 'serviceProviderList',
    component: List,
    meta: {
      keepAlive: true,
      isDistributor: true, // 校验权限是否为渠道商
      isFirstDistributor: true, // 校验是否为一级渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
  // 我的下级渠道商审批详情
  router.push({
    path: '/partner/service-provider/detail/:id',
    name: 'serviceProviderDetail',
    component: Detail,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      isFirstDistributor: true, // 校验是否为一级渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
  // 创建下级渠道商
  router.push({
    path: '/partner/service-provider/create',
    name: 'serviceProviderCreate',
    component: Create,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      isFirstDistributor: true, // 校验是否为一级渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
  // 修改下级渠道商
  router.push({
    path: '/partner/service-provider/update/:id',
    name: 'serviceProviderUpdate',
    component: Create,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      isFirstDistributor: true, // 校验是否为一级渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
  // 渠道账单总览
  router.push({
    path: '/partner/billOverview',
    name: 'billOverview',
    component: billOverview,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
  // 渠道账单明细
  router.push({
    path: '/partner/billDetails',
    name: 'billDetails',
    component: billDetails,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
  // 渠道资源账单
  router.push({
    path: '/partner/resourceBilling',
    name: 'resourceBilling',
    component: resourceBilling,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
  // 渠道商结算账单
  router.push({
    path: '/partner/channelCheckout',
    name: 'channelCheckout',
    component: channelCheckout,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      isFirstDistributor: true, // 校验是否为一级渠道商
      currPage: 'partnerServiceProviderManage',
    },
  })
}
